export default function () {
    return {
        data:{},
        dataDefault:{
            'id': '',
            'usuario_ult_alteracao': '',            
            'descricao': '',
            'tag': '',
            'valores':[
                {'id':'','value':'','label':'','ordem':1}
            ]
        },
        enumValueDefault:{
            'id':'',
            'value':'',
            'label':'',
            'ordem':null
        },
        disableForm: false,
        enums:[],
        pagination:{}
    }
  }
  